import { Controller } from "@hotwired/stimulus";

/**
 * Loading overlay controller for the messaging interface.
 * Hides the loading overlay once Rails UJS is fully loaded and ready.
 * This prevents users from interacting with links/forms before JavaScript is ready,
 * which would cause GET requests instead of proper DELETE/POST/etc requests.
 */
export default class extends Controller {
  static identifier: string;

  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }
  connect() {
    console.log(
      "[LoadingOverlay] Controller connected, readyState:",
      document.readyState,
    );

    // Wait for DOMContentLoaded to ensure Rails UJS is initialized
    if (document.readyState === "loading") {
      console.log("[LoadingOverlay] Waiting for DOMContentLoaded");
      document.addEventListener("DOMContentLoaded", () => {
        console.log("[LoadingOverlay] DOMContentLoaded fired");
        this.hideOverlay();
      });
    } else {
      // DOM already loaded, hide immediately
      console.log("[LoadingOverlay] DOM already loaded, hiding immediately");
      this.hideOverlay();
    }
  }

  private hideOverlay() {
    console.log("[LoadingOverlay] Hiding overlay with fade effect");
    // Small delay to ensure Rails UJS event handlers are attached
    setTimeout(() => {
      console.log("[LoadingOverlay] Adding fade classes");
      this.element.classList.add("opacity-0", "pointer-events-none");

      // Remove from DOM after fade animation
      setTimeout(() => {
        console.log("[LoadingOverlay] Removing overlay from DOM");
        this.element.remove();
      }, 300);
    }, 100);
  }
}
